// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_7k-0";